export {
    mergeTableAttributesAndReportColumns,
    joinReportTableDataToMenuConfigurationData,
    renameDuplicateKeyNames,
    removeKeyNamesPostfix,
} from './report-table-settings.utils';
